export default "__VITE_ASSET__ChQBT7tP__"